import loadBillToCustom from "@NA/Handlers/ADIGetBillToHandler";
//import loadADIInvoices from "@NA/Handlers/InvoiceHistory/ADIInvoiceHistoryHandler";
import { BillTo } from "@NA/Services/ADIBillToService";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import changeCustomerContext from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { BillToModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
//import { getProp } from "@insite/mobius/utilities";
import Link, { LinkProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import loadADIInvoices, { invoiceParams } from "@NA/Handlers/InvoiceHistory/ADIInvoiceHistoryHandler";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";

const mapStateToProps = (state: CustomApplicationState) => ({
    allLocationsInvoice: state.ADIGlobalData.ADIInvoiceStore.allLocationsInvoice,
    currenySymbol: state.context.session.currency?.currencySymbol,
    multipleInvoiceResult: state.ADIGlobalData.ADIInvoiceStore.multipleInvoiceResult,
    billingParentData: state.ADIGlobalData.ADIBillToStore.billToParentState,
    billingChildData: state.ADIGlobalData.ADIBillToStore.billToChildState,
    invoicePageUrl: getPageLinkByPageType(state, "InvoiceHistoryPage")?.url,
});

const mapDispatchToProps = {
    loadBillToCustom,
    changeCustomerContext,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface AllLocationInvoiceHistoryStyles {
    container?: InjectableCss;
    title?: TypographyProps;
    tableContainer?: InjectableCss;
    tableHeader?: InjectableCss;
    tableHeaderContainer?: InjectableCss;
    tableContentContainer?: InjectableCss;
    tableContent?: InjectableCss;
    toolTip?: InjectableCss;
    mobileTableContentContainer?: GridContainerProps;
    mTTotalGridItem?: GridItemProps;
    mTAgedGridItem?: GridItemProps;
    mTTotalAmountGridItem?: GridItemProps;
    mTCurrentGridItem?: GridItemProps;
    mTDPDGridItem?: GridItemProps;
    mtTableHeader?: InjectableCss;
    mtTableContent?: InjectableCss;
    mtTableContentDPDContainer?: InjectableCss;
    tabTableContentDPDContainer?: InjectableCss;
    mtTableContentDPD?: InjectableCss;
    mobiletableContainer?: InjectableCss;
    mobiletableContentcity?: InjectableCss;
    mobiletableContent?: InjectableCss;
    mobiletableHeader?: InjectableCss;
    mobiletablegrid?: InjectableCss;
    viewlink?: InjectableCss;
}

export const tableStyles: AllLocationInvoiceHistoryStyles = {
    container: {
        css: css`
            margin-top: 29px;
            .inovicemobiletable{
                ${({ theme }) => { return breakpointMediaQueries(
                    theme, [css` margin-bottom: 32px; `, css` margin-bottom: 32px; `, null, css` display:none; `,],"min",); 
    }}
    
            }
            .tablefordesktopinvoice{
            padding-bottom: 100px;
                ${({ theme }) => { return breakpointMediaQueries(
                    theme, [css` display:none;  `, css` display:none; `, css` display:none; `, null,],"max",); 
    }}
            }
            
            .invoicelocation{
                flex-direction: row;
                padding-left:0;
                padding-right:0;
                border-bottom: 1px solid #DDDDDD;
                margin-top: 15px !important;
            }
            .locationrow{
                width:auto;
                flex-basis:auto;
                padding-top: 2px;
                padding-bottom: 0;
            }
            .mobile-repeattable{
                max-width:100%;
                width:100%;
                padding:0 10px;
                border-bottom: 12px solid #f2f3f5;
                &:last-chid{
                    border:none;
                }
            }
        `,
    },
    title: {
        variant: "h3",
        as: "h2",
        css: css`
            background-color: ${ADIColors.white};
            color: ${ADIColors.darkBlue1};
            padding: 15px 0 16px 20px;
            margin-bottom: 8px;
            font-weight: 900;
            line-height: 1.25;
        `,
    },
    tableHeaderContainer: {
        css: css`
            background-color: ${ADIColors.white};
            display: flex;
            padding: 7px 0px 7px 30px;
            margin-bottom: 8px;
        `,
    },
    tableHeader: {
        css: css`
            width: 11%;
            display: flex;
            flex-basis: 11%;
            align-items: center;
            padding: 7px 10px;
            font-size: ${getProp("theme.typography.h6.size")};
            font-weight: bold;
            color: ${getColor("commom.backgroundContrast")};
            position: relative;

            &:last-child {
                width: calc(56% - 11px);
                flex-basis: calc(56% - 11px);
                text-align: center;
                border-radius: 4px;
                background-color: ${ADIColors.lightblue};
                margin-left: 28px;
                align-items: center;
                justify-content: center;
                display: flex;
                margin-right: 11px;
            }

            &.align-end {
                justify-content: flex-end;
            }

            :hover span {
                display: inline;
            }
        `,
    },
    tableContentContainer: {
        css: css`
            background-color: ${ADIColors.white};
            display: flex;
            padding: 7px 0px 7px 30px;
            margin-bottom: 8px;
        `,
    },
    tableContent: {
        css: css`
            font-size: ${getProp("theme.typography.headerTertiary.size")};
            width: 11%;
            flex-basis: 11%;
            padding: 8px 10px;
            display: flex;

            &.align-end {
                justify-content: flex-end;
                padding-right: 8px;
            }

            &.aging-price {
                width: 14%;
                flex-basis: 14%;
                border-left: solid 2px ${ADIColors.white1};
                text-align: center;
                justify-content: center;
            }

            &.aging-price.left-space {
                margin-left: 32px;
            }

            span {
                color: ${getColor("primary")};
                font-weight: bold;
                cursor: pointer;

                :hover {
                    text-decoration: underline;
                }
            }
        `,
    },
    mTTotalGridItem: {
        css: css`
            flex-basis: 50%;
            max-width: 50%;
            flex-direction: column;
            border-bottom: 1px solid ${getColor("common.border")};
            padding: 3px 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        flex-direction: row;
                        border-bottom: none;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    mTAgedGridItem: {
        css: css`
            flex-basis: 50%;
            max-width: 50%;
            flex-direction: column;
            border-bottom: 1px solid ${getColor("common.border")};
            padding: 3px 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        flex-direction: row;
                        border-bottom: none;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    mTTotalAmountGridItem: {
        css: css`
            flex-basis: 50%;
            max-width: 50%;
            flex-direction: column;
            padding: 3px 10px;
            border-bottom: 1px solid ${getColor("common.border")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        flex-direction: row;
                        border-bottom: none;
                        padding-bottom: 20px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    mTCurrentGridItem: {
        css: css`
            flex-basis: 50%;
            max-width: 50%;
            flex-direction: column;
            border-bottom: 1px solid ${getColor("common.border")};
            padding: 3px 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        flex-direction: row;
                        border-bottom: none;
                        padding-bottom: 20px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    mTDPDGridItem: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            flex-direction: column;
            padding: 3px 10px;
            margin-bottom: 20px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        border-top: 1px solid ${ADIColors.gray3};
                        padding-top: 10px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    mtTableHeader: {
        css: css`
            font-weight: bold;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        padding-right: 10px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    mtTableContent: {
        css: css``,
    },
    mtTableContentDPDContainer: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            margin:0;
            .dpdtable{
                width: 50%;
                flex-basis: 50%;
                border: none;
                padding-left: 0;
                text-align: left;
                justify-content: flex-start;
            }
            .aging-price.left-space.dpdtable{
                margin:0;
            }
        `,
    },
    tabTableContentDPDContainer: {
        css: css`
            display: flex;
            flex-wrap: nowrap;
            width: 100%;
        `,
    },
    mtTableContentDPD: {
        css: css`
            max-width: 50%;
            flex-basis: 50%;
            &:first-child {
                order: 1;
            }
            &:nth-child(2) {
                order: 3;
            }
            &:nth-child(3) {
                order: 2;
            }
            &:nth-child(4) {
                order: 4;
            }
            span {
                color: ${getColor("primary")};
                font-weight: bold;
                cursor: pointer;

                :hover {
                    text-decoration: underline;
                }
            }
        `,
        
    },
    mobileTableContentContainer: {
        css: css`
            background-color: ${getColor("common.background")};
            > ${GridOffset} {
                width: 100%;
                margin: 0;
            }
                        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        marging: 0px;
                    `,
                    null,
                    null,
                ])}
           
        `,
    },
    mobiletableHeader: {
        css: css`
            width: 100%;
            display: flex;
            flex-basis: 100%;
            align-items: center;
            padding: 7px 10px;
            font-size: ${getProp("theme.typography.h6.size")};
            font-weight: bold;
            color: ${getColor("commom.backgroundContrast")};
            position: relative;

            &:last-child {
                width: calc(100% - 11px);
                flex-basis: calc(100% - 11px);
                text-align: center;
                border-radius: 4px;
                background-color: ${ADIColors.lightblue};
                margin-left: 28px;
                align-items: center;
                justify-content: center;
                display: flex;
                margin-right: 11px;
            }

            &.align-end {
                justify-content: flex-end;
            }

            :hover span {
                display: inline;
            }
        `,
    },
    mobiletableContent: {
        css: css`
            font-size: ${getProp("theme.typography.headerTertiary.size")};
            width: 50%;
            flex-basis: 50%;
            padding: 8px 10px;
            display: flex;

            &.align-end {
                justify-content: flex-end;
                padding-right: 8px;
            }

            &.aging-price {
                width: 100%;
                flex-basis: 100%;
                border-left: solid 2px ${ADIColors.white1};
                text-align: center;
                justify-content: center;
            }

            &.aging-price.left-space {
                margin-left: 32px;
            }

            span {
                color: ${getColor("primary")};
                font-weight: bold;
                cursor: pointer;

                :hover {
                    text-decoration: underline;
                }
            }
        `,
    },
    mobiletablegrid: {
        css: css`

        width: 100%;
        flex-basis: 100%;
        max-width:100%;
        flex-direction:column;
        background: none;
        border-bottom: 1px solid #dddddd;
        .align-end{
            width: auto;
        flex-basis: auto;
        max-width:auto;
        padding:0;
        
        }
        .mobileCurrent{
            background:none;
            margin:0;
        }
        .left-align{
            padding-left:5px;
        }
        `,
    },
    viewlink: {
        css: css`


        display: flex;
        flex-direction: column;
        text-align: right;
        justify-content: flex-end;
        width: 50%;
        font-size: 14px;
    font-weight: bold;


        span{
            display: flex;
        flex-direction: column;
        text-align: right;
        justify-content: flex-end;
        width: 100%;
        font-size: 14px;
    font-weight: bold;
        }
        &:after{
            content="\f054";
        }
        `,

    },

    
};

const styles = tableStyles;

const AllLocationInvoiceHistory = ({
    allLocationsInvoice,
    currenySymbol,
    multipleInvoiceResult,
    loadBillToCustom,
    billingChildData,
    billingParentData,
    changeCustomerContext,
    invoicePageUrl,
}: Props) => {
    const [selectedSuffix, setSelectedSuffix] = React.useState("");
    const [currentAccount, setCurrentAccount] = React.useState<BillTo | null>(null);
    const [current, setCurrent] = React.useState(0);

    React.useEffect(() => {
        if (billingParentData?.billTos.length) {
            let accounts = billingParentData?.billTos;
            let selectedAccountNumber = billingParentData?.properties["currentCustomerNumber"];
            let currentAccount = accounts.filter(l => {
                return l.customerNumber === selectedAccountNumber;
            })[0];
            setCurrentAccount(currentAccount);
        }
    }, [billingParentData?.billTos]);

    React.useEffect(() => {
        if (currentAccount) {
            loadBillToCustom({
                expand: `state,validation,parent=${currentAccount.id}`,
                filter: `${currentAccount.customerNumber}-${selectedSuffix}`,
                page: "",
                pageSize: "",
                getBillingChild: true,
            });
        }
    }, [currentAccount]);

    const changeCustomer = (suffix: string) => {
        setSelectedSuffix(suffix);
        loadBillToCustom({
            expand: "state,validation,account",
            filter: "",
            page: "",
            pageSize: "",
            getBillingChild: false,
        });
    };

    React.useEffect(() => {
        if (billingChildData?.billTos.length) {
            let billTo = billingChildData.billTos[0];
            let shipTo = billTo.shipTos[0];

            if (!billTo || !shipTo) {
                return;
            }

            let state = "";
            if (currentAccount?.state != null) {
                state = currentAccount?.state.abbreviation;
            }
            let country = "";
            if (currentAccount?.country != null) {
                country = currentAccount?.country.abbreviation;
            }

            const customAddress = `
            <ul>
                <li>${currentAccount?.firstName} ${currentAccount?.lastName}</li>
                <li>${currentAccount?.companyName}</li>
                <li>${currentAccount?.address1}</li>
                <li>${currentAccount?.address2}</li>
                <li>${currentAccount?.city} ${state} ${currentAccount?.postalCode}</li>
                <li>${country}</li>
                <li>${currentAccount?.phone}</li>
                <li>${currentAccount?.email}</li>
            </ul>`;

            changeCustomerContext({
                billToId: billTo.id,
                shipToId: shipTo.id,
                returnUrl: invoicePageUrl,
                properties: {
                    CustomBillToAddress: customAddress,
                    CustomBillToId: currentAccount?.id,
                },
            } as any);
        }
    }, [billingChildData?.billTos]);

    if (!multipleInvoiceResult?.invlineitem.length || !allLocationsInvoice) {
        return null;
    }
   
    return (
        <StyledWrapper {...styles.container}>
            <Typography {...styles.title}>{translate("Invoices History")}</Typography>
            <StyledWrapper {...styles.mobiletableContainer} className="inovicemobiletable">

            {multipleInvoiceResult.invlineitem.map((invoiceItem, index) => (
    <GridContainer key={index} {...styles.tableHeaderContainer} className="mobile-repeattable">
        <GridItem {...styles.mobiletablegrid} className="invoicelocation">
        <StyledWrapper {...styles.mobiletableContent} className="locationrow">
                                {invoiceItem.showViewLink ? (
                                    <Typography as="span" onClick={() => changeCustomer(invoiceItem.customerSuffix)}>
                                        {invoiceItem.customerSuffix}
                                    </Typography>
                                ) : (
                                    invoiceItem.customerSuffix
                                )}
                            </StyledWrapper>
            <StyledWrapper {...styles.mobiletableContentcity}>{invoiceItem.city}</StyledWrapper>
            <StyledWrapper {...styles.viewlink}>
            <Link href={'MyAccount/Invoices'} >
            {translate("View")} 
                        </Link>
            </StyledWrapper>
        </GridItem>
        <GridItem {...styles.mobiletablegrid}>
            <StyledWrapper {...styles.mobiletableHeader} className="align-end">
                {translate("Total Amount:")}
                <Typography {...styles.mobiletableContent} className="align-end left-align">
                    {currenySymbol}
                    {parseFloat(invoiceItem.totAmount).toFixed(2)}
                </Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.mobiletableHeader} className="align-end mobileCurrent">
                {translate("Current:")}
                <Typography {...styles.mobiletableContent} className="align-end left-align">
                    {currenySymbol}
                    {parseFloat(invoiceItem.curAmount).toFixed(2)}
                </Typography>
            </StyledWrapper>
        </GridItem>
        <GridItem {...styles.mTDPDGridItem}>
            <StyledWrapper {...styles.mtTableHeader}>
                {translate("Days Past Due (DPD)")}
            </StyledWrapper>
            <StyledWrapper {...styles.mtTableContentDPDContainer}>
                <StyledWrapper {...styles.tableContent} className="aging-price left-space dpdtable">
                    {`${translate("1 - 30")}: ${currenySymbol}${parseFloat(invoiceItem?.tot01_30).toFixed(2)}`}
                </StyledWrapper>
                <StyledWrapper {...styles.tableContent} className="aging-price dpdtable">
                    {`${translate("31 - 60")}: ${currenySymbol}${parseFloat(invoiceItem?.tot31_60).toFixed(2)}`}
                </StyledWrapper>
                <StyledWrapper {...styles.tableContent} className="aging-price dpdtable">
                    {`${translate("61 - 90")}: ${currenySymbol}${parseFloat(invoiceItem?.tot61_90).toFixed(2)}`}
                </StyledWrapper>
                <StyledWrapper {...styles.tableContent} className="aging-price dpdtable">
                    {`${translate("91 +")}: ${currenySymbol}${parseFloat(invoiceItem?.tot90_Over).toFixed(2)}`}
                </StyledWrapper>
            </StyledWrapper>
        </GridItem>
    </GridContainer>
))}
</StyledWrapper>
        
            <StyledWrapper {...styles.tableContainer} className="tablefordesktopinvoice">
                <StyledWrapper {...styles.tableHeaderContainer}>
                    <StyledWrapper {...styles.tableHeader}>{translate("Location")} </StyledWrapper>
                    <StyledWrapper {...styles.tableHeader}>{translate("City/State")}</StyledWrapper>
                    <StyledWrapper {...styles.tableHeader} className="align-end">
                        {translate("Total Amount")}
                        
                    </StyledWrapper>
                    <StyledWrapper {...styles.tableHeader} className="align-end">
                        {translate("Current")}
                    </StyledWrapper>
                    <StyledWrapper {...styles.tableHeader}>{translate("Days Past Due (DPD)")}</StyledWrapper>
                </StyledWrapper>

                {multipleInvoiceResult.invlineitem.map(invoiceItem => {
                    return (
                        <StyledWrapper {...styles.tableContentContainer}>
                            <StyledWrapper {...styles.tableContent}>
                                {invoiceItem.showViewLink ? (
                                    <Typography as="span" onClick={() => changeCustomer(invoiceItem.customerSuffix)}>
                                        {invoiceItem.customerSuffix}
                                    </Typography>
                                ) : (
                                    invoiceItem.customerSuffix
                                )}
                            </StyledWrapper>
                            <StyledWrapper {...styles.tableContent}>{invoiceItem.city}</StyledWrapper>
                            <StyledWrapper {...styles.tableContent} className="align-end">
                                {currenySymbol}
                                {parseFloat(invoiceItem.totAmount).toFixed(2)}
                            </StyledWrapper>
                            <StyledWrapper {...styles.tableContent} className="align-end">
                                {currenySymbol}
                                {parseFloat(invoiceItem.curAmount).toFixed(2)} 
                            </StyledWrapper>

                            <StyledWrapper {...styles.tableContent} className="aging-price left-space">
                                {`${translate("1 - 30")}: ${currenySymbol}${parseFloat(invoiceItem?.tot01_30).toFixed(
                                    2,
                                )}`}
                            </StyledWrapper>
                            <StyledWrapper {...styles.tableContent} className="aging-price">
                                {`${translate("31 - 60")}: ${currenySymbol}${parseFloat(invoiceItem?.tot31_60).toFixed(
                                    2,
                                )}`}
                            </StyledWrapper>
                            <StyledWrapper {...styles.tableContent} className="aging-price">
                                {`${translate("61 - 90")}: ${currenySymbol}${parseFloat(invoiceItem?.tot61_90).toFixed(
                                    2,
                                )}`}
                            </StyledWrapper>
                            <StyledWrapper {...styles.tableContent} className="aging-price">
                                {`${translate("91 +")}: ${parseFloat(invoiceItem?.tot90_Over).toFixed(2)}`}
                            </StyledWrapper>
                        </StyledWrapper>

                        
                    );
                    
                })}

                {/* */}
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AllLocationInvoiceHistory),
    definition: {
        group: "Invoice History",
        displayName: "Invoice History All Locations",
    },
};

export default widgetModule;
